import React from 'react'

function TaxInvoices() {
  return (
    <div>TaxInvoices</div>
  )
}

export default TaxInvoices